import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppSessionService } from '../shared/services/app-session/app-session.service';
import { NavigationService } from '../shared/services/navigation/navigation.service';
import { Observable } from 'rxjs';
import { MenuDTO } from '../models/Menu/MenuDTO';
import { Store, select } from '@ngrx/store';
import { AppState, loadedMenusState } from '../store/reducers/index';
import { take, filter } from 'rxjs/operators';

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"],
})
export class WelcomeComponent implements OnInit {
  private menusList$: Observable<MenuDTO[]>;

  constructor(
    private appSession: AppSessionService,
    private router: Router,
    private store: Store<AppState>,
    private navigationService: NavigationService,
  ) {
    this.menusList$ = this.store.pipe(select(loadedMenusState), filter(menus => !!menus));
  }

  ngOnInit(): void {
    this.navigationService
      .resolveInitialRoute$(this.appSession.basePath, this.menusList$)
      .pipe(take(1))
      .subscribe((target) => {
        this.router.navigate([target]);
      });
  }
}
